import Vue from 'vue'

export type ConfirmOptionType = {
  name: string
  okHandler: () => void
  cancelHandler: () => void
}

const defaultOption: ConfirmOptionType = {
  name: 'XConfirm',
  okHandler: () => {
    /* */
  },
  cancelHandler: () => {
    /* */
  },
}
export default Vue.extend({
  methods: {
    showConfirm(option: Partial<ConfirmOptionType>) {
      const _option = Object.assign({}, defaultOption, option)
      this.$modal.show(_option.name, _option)
    },
    hideConfirm(name = 'XConfirm') {
      this.$modal.hide(name)
    },
  },
})
